<template>
  <div style="border: 1px solid #e0e0e0;">
    <div
      v-if="isLoading(reservationsLoadState)"
      class="col-md-12 text-center"
      style="mix-blend-mode: multiply;"
    >
      <v-img src="/loading.gif" />
    </div>
    <div>
      <load-state-display
        :state="reservationsLoadState"
        reload-button-id="room-reservations-reload-button"
        @reload="reloadReservations"
      />
    </div>
    <div
      v-if="isSuccess(reservationsLoadState)"
      id="room-reservations-list"
    >
      <v-list
        class="pt-0 pb-0 period-list"
      >
        <div
          v-for="period in roomReservationList"
          :key="period.name"
        >
          <period :period="period" />
        </div>
      </v-list>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import loadStateMixin from "../../mixins/load_state.js";
import Period from "./Period.vue";
import LoadStateDisplay from "../shared/LoadStateDisplay.vue";
import { LOAD_STATES } from "../../constants/load_states";

export default {
  name: "PeriodList",
  components: {
    Period,
    LoadStateDisplay
  },
  mixins: [loadStateMixin],
  data: () => ({
    reservationsLoadState: null,
    reservationsLoadTimerId: null,
  }),
  computed: {
    ...mapGetters([
      "roomReservationList",
      "periodListTimeoutId"
    ]),
  },
  watch: {
    "$route" () {
      this.startAutoReload();
    }
  },
  created() {
    this.startAutoReload();
  },
  beforeUnmount() {
    clearTimeout(this.reservationsLoadTimerId);
  },
  unmounted(){
    // 自動更新を停止する
    clearInterval(this.periodListTimeoutId);
  },
  methods: {
    fetchReservationsByRoom() {
      clearTimeout(this.reservationsLoadTimerId);
      this.reservationsLoadTimerId = setTimeout(() => {
        this.reservationsLoadState = LOAD_STATES.ERROR;
      }, 30 * 1000);

      this.$store.dispatch("fetchReservationsByRoom", {
        date: this.$route.query.date,
        room: this.$route.query.room,
      }).then(() => {
        this.reservationsLoadState = LOAD_STATES.SUCCESS;
      }).catch(() => {
        this.reservationsLoadState = LOAD_STATES.ERROR;
      }).finally(() => {
        clearTimeout(this.reservationsLoadTimerId);
      });
    },
    startAutoReload: function() {
      // 以前設定されたtimeoutをクリア
      clearInterval(this.periodListTimeoutId);
      // 最初の1回の実行
      this.reservationsLoadState = LOAD_STATES.LOADING;
      this.fetchReservationsByRoom();
      // 30秒
      var timeoutId = setInterval(this.fetchReservationsByRoom, 30 * 1000);
      this.$store.dispatch("assignPeriodListTimeoutId", timeoutId);
    },
    reloadReservations: function() {
      this.reservationsLoadState = LOAD_STATES.LOADING;
      this.fetchReservationsByRoom();
    }
  }
};
</script>
